import { Component, Input } from '@angular/core';

import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

import { FiltrableSelectComponentBase } from './filterable-select.component-base';

@Component({
	selector: 'filterable-select',
	templateUrl: 'filterable-select.html',
	styleUrls: ['filterable-select.css'],
})
export class FilterableSelectComponent extends FiltrableSelectComponentBase<any> {
	constructor() {
		super();

		// Definit comment le filtrage est effectue
		this.filteredItems$ = combineLatest([this.textFilter$, this.list$, this.reset$]).pipe(
			map(
				([filter, list, _]) => {
					if (!list) {
						return [];
					}
					
					if (!filter) {
						return [...list];
					}

					let normalizedFilter = this.normalizeValue(filter);
					return list.filter(
						(item) => {
							let label: string | undefined = this.getLabel(item);
							let normalizedLabel: string = this.normalizeValue(label);
							return normalizedLabel.includes(normalizedFilter);
						}
					);
				}
			)
		);
	}

	// La class de style a appliquer au composant de saisie
	@Input() inputClass: string = '';
}